export default __webpack_public_path__ + "static/media/Alvira.9b36e2ce.png";